import fetchItemDescriptions from '../Services/fetchItemDescriptions';

export default () => async (dispatch) => {

  dispatch(fetchItemDescriptions());

}